import { ReactNode, useEffect } from "react";
import { Flex } from "@chakra-ui/react";

import OnboardingSidebar from "../OnboardingSidebar";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useNavigate } from "react-router-dom";
import { useFeatures } from "hooks/useFeatures";

function SetupLayout({ children }: { children: ReactNode }) {
  const { user } = useTenant();
  const navigate = useNavigate();
  const { hasFeature } = useFeatures();
  const hasBankAccounts = hasFeature("connect_bank_accounts");

  const steps = [
    {
      label: "Company Info",
      path: "/setup/company",
      key: "company",
    },
    {
      label: "Add Members",
      path: "/setup/invite",
      key: "invite",
    },
    {
      label: "Sync Bank Accounts",
      path: "/setup/bank",
      key: "bank",
    },
    {
      label: "Financial Documents",
      path: "/setup/documents",
      key: "documents",
    },
  ];

  if (!hasBankAccounts) {
    const indexToRemove = steps.findIndex(step => step.key === "bank");
    steps.splice(indexToRemove, 1);
  }

  useEffect(() => {
    if (user.type === "borrower") {
      if (!user.company.address || !user.company.mailing_address) {
        navigate("/setup/company");
      } else if (!user.company.guarantor_first) {
        navigate("/setup/invite");
      } else if (user.company.plaid_tokens.length > 0) {
        navigate("/setup/documents");
      }
    } else {
      navigate("/dashboard");
    }
  }, [user]);

  return (
    <Flex bg="white" id="dashboard" minH="100vh">
      <OnboardingSidebar steps={steps} />
      {children}
    </Flex>
  );
}

export default SetupLayout;
